import { put } from '@redux-saga/core/effects';
import { addErrorNotification } from '../Notifications/redux/actionCreators';
export function putErrorNotification(message) {
    return put(addErrorNotification(message));
}
